export default {
  // serverUrl: document.location.origin,
  // serverUrl: "http://localhost:8080",
  serverUrl: "https://admission.kiut.uz",

  apiVersion: "/api/v1/",
};
